// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    marginTop: theme.spacing(8),
    width: '55rem',
    // Narrower than the page's design width, it takes the screen's width with a margin instead of scrolling sideways
    [theme.breakpoints.down('md')]: {
      width: '100%',
      minWidth: 0,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  customBundleHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  customBundlesTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  pricePerFootInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  customBundleInfoIconColor: {
    color: theme.palette.info.main,
  },
  customBundleSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: '14px',
  },
  subtitleEmphasis: {
    fontWeight: 600,
  },
  customBundlesTitle: {
    fontWeight: '600',
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  paper: {
    width: '800px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(3),
  },
  customBundlesPaper: {
    width: '100%!important',
  },
  noBundlesText: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  finishedIcon: {
    fontSize: '16px',
    verticalAlign: 'middle',
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  listItemIcon: {
    minWidth: 0,
  },
  bundleListItem: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
    paddingTop: '4px',
    paddingBottom: '4px',
  },
});

export default styles;
